module.exports = __webpack_public_path__ + "static/media/footericon.f4254598.png";